import React from 'react'
import { CustomButton, Modal, SvgWarning } from '@ui-kit'
import { AcceptConfirmModalType } from '../../utils/types'
import { NAMESPACES } from '../../utils/constants'

const AcceptConfirmModal: React.FC<AcceptConfirmModalType> = ({
  isOpen,
  closeModal,
  onYesClick,
  deleteMessage = NAMESPACES.CONFIRM_ACCEPT_CALL_MESSAGE,
}) => {
  return (
    <Modal closeModal={closeModal} isOpen={isOpen} isResizable>
      <div className="px-20 py-12 flex items-center mb-4 justify-center text-sm border-b h-[7.625rem]">
        <div className="flex items-center gap-4">
          <div className="flex gap-[1.06rem] items-center">
            <div className="flex items-center justify-center size-[3.6rem] bg-error-100 rounded-full">
              <SvgWarning />
            </div>
            <span className="text-sm font-light text-accent-700">
              {deleteMessage}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end w-full h-10">
        <CustomButton onClick={closeModal} color="primary" className="mr-3">
          {NAMESPACES.NO}
        </CustomButton>
        <CustomButton onClick={onYesClick} color="primary" isFilled>
          {NAMESPACES.YES}
        </CustomButton>
      </div>
    </Modal>
  )
}

export default AcceptConfirmModal
